module.exports = __webpack_public_path__ + "static/img/mute_camera.045e540.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/mute_camera.png
// module id = 0/za
// module chunks = 24